import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StandardTable } from '../../../../shared/components/standard-table/standard-table/standard-table';
import { CardService } from '../../../../core/services/card.service';
import { AlertService } from '../../../../shared/components/alert/alert';
import { TranslationService } from '../../../../core/services/translation.service';
import { UploadImageService } from '../../../../core/services/uploadimage.service';
import { firstValueFrom } from 'rxjs';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-card',
  imports: [CommonModule, StandardTable, FormsModule, TranslatePipe],
  templateUrl: './card.html',
  styleUrl: './card.css',
})
export class Card implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  columnList = [
    { name: 'column.icon', key: 'icon', sortable: false },
    { name: 'column.name', key: 'name', sortable: false },
    { name: 'column.action', key: 'actions', sortable: false },
  ];

  tableDataFilters: any[] = [];
  totalItems = 0;
  isLoading = false;

  currentPage = 1;
  pageSize = 10;
  searchQuery = '';

  cards: any = [];

  isSaving = false;
  isModalOpen = false;
  isEditMode = false;
  editingId: string | null = null;

  newCard = {
    icon: '',
    name: '',
  };

  imagePreview: string | null = null;
  editImage: string | null = null;
  imageFile: File | null = null;
  screenshotBase64: string | null = null;

  constructor(
    private cardService: CardService,
    private uploadImageService: UploadImageService,
    private cdr: ChangeDetectorRef,
    private alertService: AlertService,
    private translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this.loadCards();
  }

  triggerFileInput() {
    this.fileInput.nativeElement.value = '';
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreview = e.target.result;
        this.imageFile = file;
        this.screenshotBase64 = e.target.result as string;
        this.cdr.markForCheck();
      };
      reader.readAsDataURL(file);
    }
  }

  loadCards() {
    this.isLoading = true;

    const payload = {
      page: this.currentPage.toString(),
      limit: this.pageSize.toString(),
      search: this.searchQuery,
    };

    this.cardService.getAllCards(payload).subscribe({
      next: (res: any) => {
        if (res.returncode === '300') {
          this.tableDataFilters = res.data.data;
          this.totalItems = res.data.meta.totalItems || res.data.meta.total || 0;
        } else {
          this.tableDataFilters = [];
          this.totalItems = 0;
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Failed to fetch cards in admin table:', err);
        this.tableDataFilters = [];
        this.totalItems = 0;
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  search(value: string) {
    this.searchQuery = value;
    this.currentPage = 1;
    this.loadCards();
  }

  onSort(column: any) {
    console.log('Sort:', column);
  }

  onPageChange(page: any) {
    this.currentPage = page;
    this.loadCards();
  }

  onClickRow(row: any) {
    console.log('Row clicked:', row);
  }

  openCreateModal() {
    this.isEditMode = false;
    this.editingId = null;
    this.isModalOpen = true;
    this.imagePreview = null;
    this.imageFile = null;
    this.screenshotBase64 = null;
    this.newCard = {
      name: '',
      icon: '',
    };
  }

  onEdit(row: any) {
    this.isEditMode = true;
    this.editingId = row.id;
    this.isModalOpen = true;
    this.imagePreview = row.icon;
    this.editImage = row.icon;
    this.imageFile = row.icon;
    this.screenshotBase64 = row.icon;
    this.newCard = {
      name: row.name,
      icon: row.icon,
    };
  }

  onDelete(row: any) {
    if (confirm(this.translationService.translate('alert.deleteConfirm') + ` ${row.name}?`)) {
      this.cardService.deleteCard(row.id).subscribe({
        next: (res: any) => {
          if (res.returncode === '300') {
            this.alertService.success(this.translationService.translate('alert.deleteSuccess'));
            this.loadCards();
          } else {
            this.alertService.error(res.message || this.translationService.translate('alert.deleteError'));
          }
        },
        error: (err) => {
          console.error('Error deleting card:', err);
          this.alertService.error(this.translationService.translate('alert.errorOccurred'));
        },
      });
    }
  }

  closeModal() {
    this.isModalOpen = false;
  }

  // async submit() {
  //   if (!this.newCard.name) return;
  //   if (!this.imageFile) return;
  //   this.isSaving = true;
  //   const res = await firstValueFrom(
  //     this.uploadImageService.uploadImageForAdmin('cards', this.imageFile),
  //   );
  //   if (res.returncode == '300') {
  //     this.newCard.icon = res.data.url;
  //     const request = this.isEditMode
  //       ? this.cardService.updateCard({ ...this.newCard, id: this.editingId })
  //       : this.cardService.createCard(this.newCard);
  //     request.subscribe({
  //       next: (res: any) => {
  //         this.isSaving = false;
  //         if (res.returncode === '300') {
  //           this.alertService.success(
  //             `Card ${this.isEditMode ? 'updated' : 'created'} successfully`,
  //           );
  //           this.closeModal();
  //           this.loadCards();
  //         } else {
  //           this.alertService.error(
  //             res.message || `Failed to ${this.isEditMode ? 'update' : 'create'} card`,
  //           );
  //         }
  //       },
  //       error: (err) => {
  //         this.isSaving = false;
  //         console.error(`Error ${this.isEditMode ? 'updating' : 'creating'} card:`, err);
  //         this.alertService.error(
  //           `An error occurred while ${this.isEditMode ? 'updating' : 'creating'} the card`,
  //         );
  //       },
  //     });
  //   } else {
  //     this.isSaving = false;
  //     this.cdr.detectChanges();
  //     this.alertService.error(
  //       res.message || `Failed to ${this.isEditMode ? 'update' : 'create'} card`,
  //     );
  //   }
  // }

  async submit() {
    if (!this.newCard.name || !this.imageFile) return;

    this.isSaving = true;

    try {
      // Upload image only if changed
      if (this.imagePreview !== this.editImage) {
        const res = await firstValueFrom(
          this.uploadImageService.uploadImageForAdmin('card', this.imageFile)
        );

        if (res.returncode !== '300') {
          throw new Error(res.message);
        }

        this.newCard.icon = res.data.url;
      }

      const request$ = this.isEditMode
        ? this.cardService.updateCard({ ...this.newCard, id: this.editingId })
        : this.cardService.createCard(this.newCard);

      request$.subscribe({
        next: (res: any) => this.handleSuccess(res),
        error: (err) => this.handleError(err),
      });
    } catch (error: any) {
      this.isSaving = false;
      this.alertService.error(
        error.message || `Failed to ${this.isEditMode ? 'update' : 'create'} card`
      );
      this.cdr.detectChanges();
    }
  }

  private handleSuccess(res: any) {
    this.isSaving = false;

    if (res.returncode === '300') {
      this.alertService.success(
        this.translationService.translate(this.isEditMode ? 'alert.updateSuccess' : 'alert.createSuccess')
      );
      this.closeModal();
      this.loadCards();
    } else {
      this.alertService.error(
        res.message || this.translationService.translate(this.isEditMode ? 'alert.updateError' : 'alert.createError')
      );
    }

    this.cdr.detectChanges();
  }

  private handleError(err: any) {
    this.isSaving = false;
    console.error(`Error ${this.isEditMode ? 'updating' : 'creating'} card:`, err);

    this.alertService.error(this.translationService.translate('alert.errorOccurred'));

    this.cdr.detectChanges();
  }
}
